<script setup lang="ts">
import type { Icons } from '@/components/base/BaseIcon.vue'
import type { FeedActivity } from '@/types/customer/ActivitiesFeed'
import ActivityCardBase from './ActivityCardBase.vue'

const { t } = useI18n()

const props = defineProps<{
  activity: FeedActivity
  showConnector?: boolean
}>()

const channel = computed(() => (props.activity.type.startsWith('sms.') ? 'sms' : 'email'))

const action = computed(() => props.activity.type.split('.')[1] as 'optin' | 'optout' | 'optunknown')

const description = computed(() => {
  return t(`pages.customer.customerDetailPage.blocks.activity.consent.${channel.value}.${action.value}`)
})

const icons: Record<typeof action.value, Icons> = {
  optin: 'HeroCheckCircleIconSolid',
  optout: 'HeroNoSymbolIconSolid',
  optunknown: 'HeroQuestionMarkCircleIconSolid'
}

const icon = computed(() => icons[action.value])

const iconColor = computed(() => {
  return {
    optin: 'bg-green-500',
    optout: 'bg-red-500',
    optunknown: 'bg-muted-foreground'
  }[action.value]
})
</script>

<template>
  <ActivityCardBase
    :icon="icon"
    :icon-color="iconColor"
    :occurred-at="activity.occurred_at"
    :show-connector="showConnector"
  >
    <template #description>
      <p class="text-sm text-muted-foreground">{{ description }}</p>
    </template>
  </ActivityCardBase>
</template>
